import React from "react";
import { Route } from "react-router-dom";

const renderRouter = (routers: any) => {
  const normalRouter = routers.filter(
    item => !item.isCheckRole && !item.isHide
  );

  const _normalRouter = normalRouter.map(
    ({ exact, strict, path, title = "", params = {}, Component }, index) => (
      <Route
        key={index}
        exact={exact}
        strict={strict}
        path={path}
        render={props => (
          <Component
            type={params.type}
            header={params.header}
            icon={params.icon}
            id={props.match.params.id}
            title={title}
          />
        )}
      />
    )
  );

  return <>{_normalRouter}</>;
};

export default renderRouter;
